import {Component, OnInit} from '@angular/core';

declare var $: any;
import {SucursalService} from './sucursal.service';
import {ProvinciaService} from '../provincia/provincia.service';
import {InformeService} from '../informes/informe.service';
import {MedicionService} from '../medicion/medicion.service';
import {Sucursal} from './sucursal';
import {Contacto} from './contacto';
import {Empresa} from '../empresa/empresa';
import {EmpresaService} from '../empresa/empresa.service';
import {PermisoService} from '../permiso/permiso.service';
import {Provincia} from '../provincia/provincia';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginService} from '../login/login.service';
import 'rxjs/Rx';

import myGlobals = require('../config');
import {HusoHorarioService} from "../husoHorario/husoHorario.service";
import {HusoHorario} from "../husoHorario/husoHorario";
import {NodoService} from "../nodo/nodo.service";

var moment = require('moment');

@Component({
    selector: 'sucursal',
    template: require('../../app/sucursal/sucursal.component.html'),
    styles: [require('../../app/sucursal/sucursal.component.css')]
})
export class SucursalComponent implements OnInit {
    sucursal: Sucursal;
    empresa: any;
    empresas: Empresa;
    contacto: Contacto;
    idSeleccionado;
    modificoContacto;
    active: any;
    active2: any;
    provincias: Provincia[];
    localidades: any;
    deshabilitar: boolean;
    permisos: any;
    historico_dias: any;
    usuario: any;
    reporte: any;
    husosHorarios: HusoHorario[];
    idFolderGoogleDrive: string;
    today: string;
    nodos: string[];

    constructor(private sucursalService: SucursalService,
                private empresaService: EmpresaService,
                private provinciaService: ProvinciaService,
                private informeService: InformeService,
                private medicionService: MedicionService,
                private route: ActivatedRoute,
                private loginService: LoginService,
                private permisoService: PermisoService,
                private nodoService: NodoService,
                private router: Router,
                private husoHorarioService: HusoHorarioService) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        //Perdir permisos
        this.permisos = new Map();
        this.permisoService.getPermiso("sucursal").subscribe(permisos => {
            for (let permiso of permisos.tipoPermiso) {
                this.permisos.set(permiso.descripcion, true);
            }
            //Si no tiene permiso para ver redirijo
            if (!this.permisos.get("read"))
                this.router.navigate(['/home']);
        });

        //Inicializar tabla
        $("#grid-data").bootgrid({
            ajax: true,
            url: myGlobals.default.BASE_URL + "/sucursal/sucursalesTable",
            selection: true,
            multiSelect: false,
            rowSelect: true,
            formatters: {
                "empresa": function (column, row) {
                    return row.empresa.descripcion;
                },
                "estado": function (column, row) {
                    return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>"
                },
                "central": function (column, row) {
                    return row.central == true ? "Sí" : "No"
                },
                "fechaCalibracion": function (column, row) {
                    if (row.fechaCalibracion) {
                        return moment(row.fechaCalibracion, "YYYY-MM-DD").format("DD-MM-YYYY");
                    } else
                        return "";

                },
            },
            ajaxSettings: {
                headers: {
                    "Authorization": this.loginService.getToken()
                },
                method: "GET"
            }
        })
        //Cerrar alert
        $("#alertSeleccion").hide();
        //Inicializar banderas para resetear forms
        this.active = true;
        this.active2 = true;
        //Inicializar sucursal
        this.sucursal = new Sucursal();
        //Incializar contacto
        this.contacto = new Contacto();
        //Inicializar bandera deshabilitar
        this.deshabilitar = false;
        //Cargar empresas
        this.empresaService.getEmpresas()
            .subscribe(empresas => {
                this.empresas = empresas;
            });
        this.sucursal.contacto = [];
        //Inicilizar bandera
        this.modificoContacto = false;
        //Cargar provincias
        this.provinciaService.getProvincias()
            .subscribe(provincias => {
                this.provincias = provincias;
            });
        //Cargar husos horarios
        this.husoHorarioService.getHusosHorarios()
            .subscribe((husosHorario) => {
                this.husosHorarios = husosHorario;
            })

        //Usuario logueado
        this.usuario = this.loginService.getDecodeToken();
        //Reporte
        this.reporte = {};
        this.today = new Date().toJSON().split('T')[0];
    }

    ngOnDestroy() {
    }

    agregar() {
        //Inicializo variables
        this.sucursal = new Sucursal();
        this.contacto = new Contacto();
        this.deshabilitar = false;
        this.modificoContacto = false;
        //Mostrar modal
        $("#modalSucursal").modal("show");
        //Cerrar alert
        $("#alertSeleccion").hide();
        //Reseteo formSucursal para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Reseteo formContacto para eliminar errores
        setTimeout(() => this.active2 = false, 0);
        setTimeout(() => this.active2 = true, 0);
    }

    modificar() {
        this.modificoContacto = false;
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        } else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco sucursal
                this.sucursalService
                    .getSucursal(this.idSeleccionado)
                    .subscribe(sucursal => {
                        this.sucursal = sucursal;
                        this.cambiarLocalidades(sucursal.provincia);
                        this.sucursal.fechaCalibracion = this.sucursal.fechaCalibracion.toString().slice(0, 10);
                    });
                //Seteo bandera para deshabilitar
                this.deshabilitar = false;
                //Ocultar modal
                $("#modalSucursal").modal("show");
            }
        }
    }

    eliminar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        } else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco sucursal
                this.sucursalService
                    .getSucursal(this.idSeleccionado)
                    .subscribe(sucursal => {
                        this.sucursalService.delete(sucursal).subscribe(() => $("#grid-data").bootgrid("reload"));

                    });
            }
        }
    }

    ver() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        } else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco sucursal
                this.sucursalService
                    .getSucursal(this.idSeleccionado)
                    .subscribe(sucursal => {
                        this.sucursal = sucursal;
                        this.cambiarLocalidades(sucursal.provincia);
                    });
                //Seteo bandera para deshabilitar
                this.deshabilitar = true;
                //Muestro modal
                $("#modalSucursal").modal("show");

            }
        }
    }

    verReporte() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        } else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Seteo bandera para deshabilitar
                this.deshabilitar = false;
                //Muestro modal
                $("#modalReporte").modal("show");

            }
        }
    }

    save() {
        this.sucursalService
            .save(this.sucursal)
            .subscribe((sucursal) => {
                this.sucursal = sucursal;
                //Inicializo variables
                this.sucursal = new Sucursal();
                this.contacto = new Contacto();
                //Ocultar modal
                $("#modalSucursal").modal("hide");
                //Reseteo formSucursal para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
                //Recargo tabla
                $("#grid-data").bootgrid("reload");
            })
    }

    generarReporte() {
        this.deshabilitar = true;
        //Obtener id seleccionado
        let id = $("#grid-data").bootgrid("getSelectedRows")[0];
        var tblData = $("#grid-data").bootgrid("getCurrentRows");
        let filename = '';
        for (var i = 0; i < tblData.length; i++) {
            if (tblData[i]['_id'] == id) {
                filename = filename + tblData[i]['descripcion'] + '-' + tblData[i]['empresa']['descripcion'];
                break;
            }
        }
        this.informeService.getInformeMantenimiento(this.idSeleccionado, this.reporte, filename)
            .subscribe((res) => {
                this.deshabilitar = false;
                this.reporte = {};
                //Ocultar modal
                $("#modalReporte").modal("hide");
                //Reseteo formSucursal para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
                //Recargo tabla
                $("#grid-data").bootgrid("reload");
            })
    }

    handleAcceptReport() {
        if (this.reporte.type === 'mediciones')
            this.exportMediciones();
        else
            this.generarReporteGeneral();
    }

    generarReporteGeneral() {
        this.deshabilitar = true;
        this.informeService.getInformeGeneral(this.idSeleccionado, this.reporte)
            .subscribe((res) => {
                this.deshabilitar = false;
                this.reporte = {};
                //Ocultar modal
                $("#modalMediciones").modal("hide");
                //Reseteo formSucursal para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
            })
    }

    generarConfiguracionSucursal() {
        this.deshabilitar = true;
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        this.informeService.getConfiguracionSucursal(this.idSeleccionado)
            .subscribe((res) => {
                this.deshabilitar = false;
                this.reporte = {};
            })
    }

    exportMediciones() {
        this.deshabilitar = true;
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        this.medicionService.getAllMedicionesBySucursalYFecha(this.idSeleccionado, this.reporte.fechaDesde, this.reporte.fechaHasta, null)
            .subscribe((res) => {
                this.deshabilitar = false;
                this.reporte = {};
                //Ocultar modal
                $("#modalReporte").modal("hide");
                //Reseteo formSucursal para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
                this.cerrarModalMediciones();
            })
    }

    agregarContacto() {
        if (!this.modificoContacto) {
            //Inicializar arreglo
            if (this.sucursal.contacto == undefined)
                this.sucursal.contacto = [];
            //Agregar contacto
            this.sucursal.contacto.push(this.contacto);
            //Limpiar contacto
            this.contacto = new Contacto();
        } else {
            //Limpiar contacto
            this.contacto = new Contacto();
            //Seteo bandera
            this.modificoContacto = false;
        }
        //Reseteo formContacto para eliminar errores
        setTimeout(() => this.active2 = false, 0);
        setTimeout(() => this.active2 = true, 0);
    }

    modificarContacto(index) {
        //Traer contacto
        this.contacto = this.sucursal.contacto[index];
        //Seteo bandera
        this.modificoContacto = true;
    }

    eliminarContacto(index) {
        //Eliminar contacto de la lista
        this.sucursal.contacto.splice(index, 1);
    }

    hideAlert() {
        $("#alertSeleccion").hide();
    }

    cambiarLocalidades(nombre) {
        this.provinciaService.getProvincia(nombre)
            .subscribe(provincia => {
                this.localidades = provincia.localidades;
            });
        console.log(this.sucursal);
    }

    setearEmpresa(id) {
        this.sucursal.empresa = id;
    }

    cerrarModal() {
        //Reseteo formSucursal para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Reseteo formContacto para eliminar errores
        setTimeout(() => this.active2 = false, 0);
        setTimeout(() => this.active2 = true, 0);
        this.sucursal = new Sucursal();
        $("#modalSucursal").modal("hide");
    }

    cerrarModalReporte() {
        //Reseteo formSucursal para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Reseteo formContacto para eliminar errores
        setTimeout(() => this.active2 = false, 0);
        setTimeout(() => this.active2 = true, 0);
        this.sucursal = new Sucursal();
        $("#modalReporte").modal("hide");
    }

    cerrarModalMediciones() {
        //Reseteo formSucursal para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Reseteo formContacto para eliminar errores
        setTimeout(() => this.active2 = false, 0);
        setTimeout(() => this.active2 = true, 0);
        $("#modalMediciones").modal("hide");
    }

    openModalMediciones(type) {
        this.reporte.type = type;
        if (type === 'mediciones') {
            //Obtener id seleccionado
            this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
            //Si no hay nada seleccionado mostrar alert
            if (this.idSeleccionado == undefined) {
                $("#alertSeleccion").show();
            } else {
                if (this.idSeleccionado != "0") {
                    //Cerrar alert
                    $("#alertSeleccion").hide();
                    //Seteo bandera para deshabilitar
                    this.deshabilitar = false;
                    //Muestro modal
                    $("#modalMediciones").modal("show");
                    var date = new Date();
                    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
                    var lastDay = new Date();
                    this.reporte.fechaDesde = firstDay.toISOString().split('T')[0];
                    this.reporte.fechaHasta = lastDay.toISOString().split('T')[0];
                }
            }
        } else {
            //Obtener id seleccionado
            this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
            //Cerrar alert
            $("#alertSeleccion").hide();
            //Seteo bandera para deshabilitar
            this.deshabilitar = false;
            //Muestro modal
            $("#modalMediciones").modal("show");
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date();
            if (this.idSeleccionado && this.idSeleccionado != "0") {
                this.reporte.sucursal_id = (this.idSeleccionado);
                this.nodoService.getNodosBySucursal((this.idSeleccionado)).subscribe((data) => {
                    this.nodos = data;
                });
            }
            this.reporte.fechaDesde = firstDay.toISOString().split('T')[0];
            this.reporte.fechaHasta = lastDay.toISOString().split('T')[0];
        }
    }

    seleccionarNodo(e, nodo) {
        if (!this.reporte.nodos) {
            this.reporte.nodos = [];
        }

        const index = this.reporte.nodos.indexOf(nodo._id);

        if (e.target.checked) {
            if (index === -1) {
                this.reporte.nodos.push(nodo._id);
            }
        } else {
            if (index !== -1) {
                this.reporte.nodos.splice(index, 1);
            }
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/sucursal/sucursal.component.ts